<template>
  <div class="h-100">
    <header-component />

    <transition name="slide-left" mode="out-in">
      <side-bar-component />
    </transition>

    <div
      class="title-bar bg-light py-3"
      :class="{ 'menu-open': menuState == 'open' }"
    >
      <div class="container-fluid" :class="{ 'pl-0': menuState == 'open' }">
        <div class="row pt-2">
          <div class="col-12">
            <h3 class="font-weight-500 m-0">{{ title }}</h3>
          </div>
          <div class="col-md-auto text-md-right pt-1">
            <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column justify-content-between h-100">
    <main class="container-fluid" :class="{ 'menu-open': menuState == 'open' }">
      <transition name="slide-left" mode="out-in">
        <router-view />
      </transition>
    </main>

    <footer
      class="bg-light py-3"
      :class="{ 'menu-open': menuState == 'open' }"
    >
      <div class="container-fluid">
        <div class="row my-4">
          <div class="col-md-6">
            <div class="text-center text-md-left text-muted">
              © <a href="https://niftybit.co.za">NiftyBit.</a> All Rights
              Reserved
            </div>
          </div>
          <div class="col-md-6 text-center text-md-right">
            <div class="text-muted">
              Version <strong>{{ version }}</strong> |
              <router-link :to="{ name: 'support' }"
                ><i class="lni lni-headphone-alt"></i> Support Contact
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </footer>

    </div>


  </div>
</template>

<script>
import headerComponent from "@/layouts/partials/TheAppHeader";
import sideBarComponent from "@/layouts/partials/TheAppSideBar";

export default {
  data() {
    return {
      breadcrumbs: [],
      title: "",
      version: process.env.VUE_APP_VERSION,
    };
  },

  mounted() {
    this.breadcrumbs = this.$route.meta.breadcrumb;
    this.title = this.$route.meta.title;
  },

  watch: {
    $route() {
      this.breadcrumbs = this.$route.meta.breadcrumb;
      this.title = this.$route.meta.title;
    },
  },

  components: {
    sideBarComponent,
    headerComponent,
  },

  computed: {
    menuState() {
      return this.$store.getters["menu/menuState"];
    },
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.title-bar {
  margin-top: 60px;
}

main {
  margin-top: 40px;
}

@media (min-width: 1200px) {
.title-bar {
  margin-top: 90px;
}
}

.menu-open {
}

@media (min-width: 992px) {
  .menu-open {
    padding-left: 266px;
  }
}
</style>
